import React from 'react';
import UserRoutes from './Routes';
import AdminRoutes from '../containers/Admin/Routes';

const Usuario = () => {
  return (
    <div>
      <UserRoutes />
      <AdminRoutes />
    </div>
  );
}
export default Usuario;